module.exports = __webpack_public_path__ + "img/casual-life-3d-young-woman-standing-and-pointing-at-her-phone.e582d700.png";